// extracted by mini-css-extract-plugin
export var box = "DirectionCard-module--box--a8994";
export var box_md = "DirectionCard-module--box_md--ff28f";
export var box_xmd = "DirectionCard-module--box_xmd--3f3bc";
export var box_flex = "DirectionCard-module--box_flex--eb5a6";
export var box_lg = "DirectionCard-module--box_lg--2890c";
export var box_sm = "DirectionCard-module--box_sm--60984";
export var box_outer = "DirectionCard-module--box_outer--7acb3";
export var box_whiteBg = "DirectionCard-module--box_white-bg--cce6c";
export var box_noMarginBottom = "DirectionCard-module--box_no-margin-bottom--1e4d2";
export var box_noPadding = "DirectionCard-module--box_no-padding--294da";
export var box_outerGray = "DirectionCard-module--box_outer-gray--e0d01";
export var box_dark = "DirectionCard-module--box_dark--2ed65";
export var box_zIndex = "DirectionCard-module--box_z-index--a7823";
export var box_zIndex6 = "DirectionCard-module--box_z-index-6--e2d92";
export var box_eventsWithLine = "DirectionCard-module--box_events-with-line--9646e";
export var box_featuresAo = "DirectionCard-module--box_features-ao--e2d2a";
export var box_verticalPaddings = "DirectionCard-module--box_vertical-paddings--11435";
export var clearP = "DirectionCard-module--clearP--489e3";
export var clearP_vc = "DirectionCard-module--clearP_vc--5dcca";
export var card = "DirectionCard-module--card--64732";
export var title = "DirectionCard-module--title--2507f";
export var list = "DirectionCard-module--list--7d18b";
export var software = "DirectionCard-module--software--3061e";
export var button = "DirectionCard-module--button--6f341";
export var fadeInAnimation = "DirectionCard-module--fadeInAnimation--97b4d";
export var placeHolderShimmer = "DirectionCard-module--placeHolderShimmer--7b0c6";